var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2874_13084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.44903 23.0305V7.54985H0.303579V23.0305H5.44903ZM2.87697 5.43496C4.67128 5.43496 5.78815 4.24622 5.78815 2.7607C5.75472 1.24168 4.67135 0.0859375 2.91102 0.0859375C1.15097 0.0859375 0 1.2417 0 2.7607C0 4.24629 1.1166 5.43496 2.84338 5.43496H2.87681H2.87697ZM8.29702 23.0305H13.4425V14.3853C13.4425 13.9227 13.4759 13.4605 13.6118 13.1297C13.9838 12.2053 14.8304 11.2479 16.2518 11.2479C18.1137 11.2479 18.8586 12.6675 18.8586 14.7486V23.0304H24.0037V14.1539C24.0037 9.39888 21.4652 7.1864 18.0798 7.1864C15.3041 7.1864 14.0853 8.73796 13.4082 9.79472H13.4426V7.54952H8.29714C8.36467 9.00214 8.29714 23.0302 8.29714 23.0302L8.29702 23.0305Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2874_13084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22.9445,
    fill: "white",
    transform: "translate(0 0.0859375)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b6824208738a0ca506dada4bc52aa2f7.svg";
export { ForwardRef as ReactComponent };